import { FC } from 'react';

interface InternalStatusPulseProps {
    active: boolean;
}

export const InternalStatusPulse: FC<InternalStatusPulseProps> = ({ active }) => (
    <div className="flex items-center gap-2.5">
        <div className="relative flex h-2 w-2">
            {active && (
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            )}
            <span className={`relative inline-flex rounded-full h-2 w-2 ${active ? 'bg-emerald-500' : 'bg-rose-500'}`} />
        </div>
        <span className={`text-[11px] font-bold tracking-tight ${active ? 'text-emerald-600' : 'text-rose-600'}`}>
            {active ? 'OPERATIONAL' : 'SYSTEM OFFLINE'}
        </span>
    </div>
);
